import React from 'react';
import { Category } from '../types/template';
import './CategoryMenu.css';

interface CategoryMenuProps {
  categories: Category[];
  activeCategory: string;
  onCategoryChange: (categoryId: string) => void;
}

const CategoryMenu: React.FC<CategoryMenuProps> = ({
  categories,
  activeCategory,
  onCategoryChange,
}) => {
  return (
    <div className="category-menu">
      <div className="category-list">
        {categories.map((category) => (
          <button
            key={category.id}
            className={`category-item ${
              activeCategory === category.id ? 'active' : ''
            }`}
            onClick={() => onCategoryChange(category.id)}
          >
            {category.name}
          </button>
        ))}
      </div>
    </div>
  );
};

export default CategoryMenu;
